import {
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CRow,
} from '@coreui/react'
import { Language } from '../../language/English'

export const AccessDenied = () => {
  return (
    <div className="bg-light min-vh-100 d-flex align-items-center">
      <CContainer>
        <CRow className="justify-content-center text-center">
          <CCol md={6} lg={5}>
            <CCard className="shadow-sm border-0">
              <CCardBody className="p-5">
                <h4 className="mb-3">{ Language.ACCESS_DENIED }</h4>
                <p className="text-medium-emphasis mb-4">
                  { Language.ACCESS_DENIED_DESCRIPTION }
                </p>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}
